import { render, staticRenderFns } from "./MealHolidayConfig.vue?vue&type=template&id=25a1fe15&scoped=true"
import script from "./MealHolidayConfig.vue?vue&type=script&lang=js"
export * from "./MealHolidayConfig.vue?vue&type=script&lang=js"
import style0 from "./MealHolidayConfig.vue?vue&type=style&index=0&id=25a1fe15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a1fe15",
  null
  
)

export default component.exports